//blue base collection
// import {darkestRed, grayBeige, softRed} from "../n12/_n12_colors";

export const blueVioletColor = '#3f51b5';
export const skyBlueColor = '#00aaff';
export const oceanBlueColor = '#0088cc';
export const secondaryBgColor = '#E3F6FF';
//white-Gray base collection
export const shadowColor = '#4c4c4c';
export const brightGreyColor = '#5a5b5e';
export const smokeWhiteColor = '#f5f5f5';
//silver-Gray base collection
export const silverSmokeColor = '#D3D3D3';
export const silverGrayColor = '#A2A2A2';
export const silverSpoonColor = '#647171';
//red base collection
export const roseColor = '#c43a31';
export const cherryJamColor = '#8a1212';
export const honeyColor = '#F2BB0A';
//Stacked chart
export const yellowColor = '#ffdd22';
// Grey
export const darkGrey = '#818386';

//pie
export const pieChartColors = ['#AE0721', '#818386', '#d90000', '#890505', '#6a6a6a'];

export const barColors = [roseColor, honeyColor, yellowColor];

